<template>
  <div class="vip-coupon-page">
    <div class="toolbar">
      <el-button type="primary" @click="openDialog">新增优惠码</el-button>
    </div>
    <el-table :data="list" stripe style="width:100%">
      <el-table-column prop="id" label="ID" width="80" />
      <el-table-column prop="code" label="优惠码" width="160" />
      <el-table-column prop="name" label="名称" />
      <el-table-column label="类型" width="120">
        <template #default="{row}">
          <el-tag v-if="Number(row.type) === 1" type="success">固定金额</el-tag>
          <el-tag v-else-if="Number(row.type) === 2" type="warning">折扣比例</el-tag>
          <el-tag v-else>未知</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="值" width="160">
        <template #default="{row}">
          <span v-if="Number(row.type) === 1">{{ (Number(row.value) / 100).toFixed(2) }} 元</span>
          <span v-else-if="Number(row.type) === 2">{{ Number(row.value) }} %</span>
          <span v-else>—</span>
        </template>
      </el-table-column>
      <el-table-column prop="limit_use" label="总次数上限" width="120" />
      <el-table-column prop="limit_use_with_user" label="单用户上限" width="120" />
      <el-table-column prop="limit_plan_ids" label="限定套餐" width="160" show-overflow-tooltip />
      <el-table-column prop="limit_period" label="限定周期" width="160" show-overflow-tooltip />
      <el-table-column label="有效期" width="240">
        <template #default="{row}">
          <div>{{ formatTime(row.started_at) }} ~ {{ formatTime(row.ended_at) }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="show" label="启用" width="100">
        <template #default="{row}">
          <el-switch v-model="row.show" :active-value="1" :inactive-value="0" @change="toggleShow(row)" />
        </template>
      </el-table-column>
      <el-table-column label="操作" width="200">
        <template #default="{row}">
          <el-button size="small" @click="edit(row)">编辑</el-button>
          <el-button size="small" type="danger" @click="remove(row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination class="pager" :current-page="pagination.page" :page-size="pagination.pageSize" :total="pagination.total" layout="prev, pager, next" @current-change="pageChange" />

    <el-dialog v-model="dialogVisible" :title="form.id ? '编辑优惠码' : '新增优惠码'" width="700px">
      <el-form :model="form" label-width="140px">
        <el-form-item label="优惠码">
          <el-input v-model="form.code" placeholder="请输入唯一优惠码" />
        </el-form-item>
        <el-form-item label="名称">
          <el-input v-model="form.name" placeholder="用于展示的名称" />
        </el-form-item>
        <el-form-item label="类型">
          <el-radio-group v-model="form.type">
            <el-radio :label="1">固定金额</el-radio>
            <el-radio :label="2">折扣比例</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item v-if="form.type === 1" label="优惠金额（元）">
          <el-input-number v-model="form.value_yuan" :min="0" :step="1" />
        </el-form-item>
        <el-form-item v-else label="折扣比例（%）">
          <el-input-number v-model="form.value_percent" :min="0" :max="100" :step="1" />
        </el-form-item>
        <el-form-item label="启用">
          <el-switch v-model="form.show" :active-value="1" :inactive-value="0" />
        </el-form-item>
        <el-form-item label="总使用次数上限">
          <el-input-number v-model="form.limit_use" :min="0" />
        </el-form-item>
        <el-form-item label="单用户使用上限">
          <el-input-number v-model="form.limit_use_with_user" :min="0" />
        </el-form-item>
        <el-form-item label="限定套餐ID(逗号)">
          <el-input v-model="form.limit_plan_ids" placeholder="如：1,2,3；为空不限制" />
        </el-form-item>
        <el-form-item label="限定周期(逗号)">
          <el-input v-model="form.limit_period" placeholder="如：month,year；为空不限制" />
        </el-form-item>
        <el-form-item label="开始时间">
          <el-date-picker v-model="form.started_at_ms" type="datetime" value-format="x" placeholder="选择开始时间" />
        </el-form-item>
        <el-form-item label="结束时间">
          <el-date-picker v-model="form.ended_at_ms" type="datetime" value-format="x" placeholder="选择结束时间" />
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="dialogVisible=false">取消</el-button>
        <el-button type="primary" :loading="loading" @click="submit">确定</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import request from '../../utils/request'

const list = ref([])
const pagination = ref({ page: 1, pageSize: 20, total: 0 })
const dialogVisible = ref(false)
const loading = ref(false)
const form = ref({
  id: null,
  code: '',
  name: '',
  type: 1,
  value_yuan: 0,
  value_percent: 0,
  show: 1,
  limit_use: null,
  limit_use_with_user: null,
  limit_plan_ids: '',
  limit_period: '',
  started_at_ms: null,
  ended_at_ms: null
})

const formatTime = (ts) => {
  if (!ts) return '—'
  const d = new Date(ts * 1000)
  const y = d.getFullYear()
  const m = String(d.getMonth() + 1).padStart(2, '0')
  const da = String(d.getDate()).padStart(2, '0')
  const hh = String(d.getHours()).padStart(2, '0')
  const mm = String(d.getMinutes()).padStart(2, '0')
  return `${y}-${m}-${da} ${hh}:${mm}`
}

const loadList = async () => {
  const params = { page: pagination.value.page, pageSize: pagination.value.pageSize }
  try {
    const data = await request.get('/v1/admin/vip-coupon/list', { params })
    list.value = (data.list || []).map(it => {
      const typeNum = Number(it.type || 0)
      const valueNum = Number(it.value || 0)
      return {
        ...it,
        type: isNaN(typeNum) ? 0 : typeNum,
        value: isNaN(valueNum) ? 0 : valueNum,
        show: Number(it.show || 0),
        started_at: Number(it.started_at || 0),
        ended_at: Number(it.ended_at || 0)
      }
    })
    pagination.value.total = data.pagination?.total || list.value.length
  } catch (e) {
    ElMessage.error(e.toString())
  }
}

const pageChange = (p) => { pagination.value.page = p; loadList() }

const openDialog = () => {
  form.value = {
    id: null,
    code: '',
    name: '',
    type: 1,
    value_yuan: 0,
    value_percent: 0,
    show: 1,
    limit_use: null,
    limit_use_with_user: null,
    limit_plan_ids: '',
    limit_period: '',
    started_at_ms: null,
    ended_at_ms: null
  }
  dialogVisible.value = true
}

const edit = (row) => {
  form.value = {
    id: row.id,
    code: row.code,
    name: row.name,
    type: Number(row.type) || 1,
    value_yuan: Number(row.type) === 1 ? (row.value ? (Number(row.value) / 100) : 0) : 0,
    value_percent: Number(row.type) === 2 ? (Number(row.value) || 0) : 0,
    show: Number(row.show || 0),
    limit_use: row.limit_use ?? null,
    limit_use_with_user: row.limit_use_with_user ?? null,
    limit_plan_ids: row.limit_plan_ids || '',
    limit_period: row.limit_period || '',
    started_at_ms: row.started_at ? row.started_at * 1000 : null,
    ended_at_ms: row.ended_at ? row.ended_at * 1000 : null
  }
  dialogVisible.value = true
}

const submit = async () => {
  if (!form.value.code || !form.value.name) {
    ElMessage.warning('请填写优惠码和名称')
    return
  }
  if (form.value.type === 1 && (!form.value.value_yuan || form.value.value_yuan <= 0)) {
    ElMessage.warning('请输入有效的优惠金额')
    return
  }
  if (form.value.type === 2 && (form.value.value_percent == null || form.value.value_percent < 0 || form.value.value_percent > 100)) {
    ElMessage.warning('请输入0-100的折扣比例')
    return
  }
  loading.value = true
  try {
    const payload = {
      id: form.value.id,
      code: form.value.code,
      name: form.value.name,
      type: form.value.type,
      value: form.value.type === 1 ? Math.round((form.value.value_yuan || 0) * 100) : Math.round(form.value.value_percent || 0),
      show: form.value.show,
      limit_use: form.value.limit_use ?? null,
      limit_use_with_user: form.value.limit_use_with_user ?? null,
      limit_plan_ids: form.value.limit_plan_ids || null,
      limit_period: form.value.limit_period || null,
      started_at: form.value.started_at_ms ? Math.floor(form.value.started_at_ms / 1000) : null,
      ended_at: form.value.ended_at_ms ? Math.floor(form.value.ended_at_ms / 1000) : null
    }
    if (form.value.id) {
      await request.post('/v1/admin/vip-coupon/update', payload)
    } else {
      await request.post('/v1/admin/vip-coupon/create', payload)
    }
    ElMessage.success('操作成功')
    dialogVisible.value = false
    loadList()
  } catch (e) {
    ElMessage.error('保存失败：' + e.toString())
  } finally {
    loading.value = false
  }
}

const remove = async (row) => {
  try {
    await ElMessageBox.confirm('确定要删除这个优惠码吗？', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    })
    await request.post('/v1/admin/vip-coupon/delete', { id: row.id })
    ElMessage.success('删除成功')
    loadList()
  } catch (e) {
    if (e !== 'cancel') {
      ElMessage.error(e.toString())
    }
  }
}

const toggleShow = async (row) => {
  try {
    await request.post('/v1/admin/vip-coupon/update', { id: row.id, show: row.show })
    ElMessage.success('状态已更新')
  } catch (e) {
    ElMessage.error('更新失败：' + e.toString())
    row.show = row.show ? 0 : 1
  }
}

loadList()
</script>

<style scoped>
.vip-coupon-page .toolbar { margin-bottom: 15px; }
.pager { margin-top: 15px; text-align: right; }
</style>
